import { render, staticRenderFns } from "./referraldynamic.vue?vue&type=template&id=edaea242"
import script from "./referraldynamic.vue?vue&type=script&lang=js"
export * from "./referraldynamic.vue?vue&type=script&lang=js"
import style0 from "./referraldynamic.vue?vue&type=style&index=0&id=edaea242&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports